import { BodyScanTypes } from '../bodyscan';

export interface IWorkoutTotals {
  total?: number;
  build?: number;
  burn?: number;
}

export interface IMuscleGroupPercentages {
  backAndArms?: number;
  upperAndArms?: number;
  lower?: number;
}

export interface IGraphYAxis {
  min: number;
  max: number;
  ticks: number;
}

export interface IGraphDataPoints {
  x: string;
  y?: number;
}

export interface IStat {
  description: string;
  valAndUnit?: string;
  changeVal?: number;
  changeUnit?: string;
  changeDescription?: string;
  graphYAxis?: IGraphYAxis;
  graphDataPoints?: IGraphDataPoints[];
  error?: string;

  rangeDegrees?: { [x: string]: number; };
  rangePercentages?: { [x: string]: number; };
  rangeValues?: { [x: string]: number; };
  valuePercent?: number;
  type?: BodyScanTypes;
}

export interface IScanStats {
  scanDate?: string;
  totalBodyWeight: IStat;
  muscleMass: IStat;
  fat: IStat;
}

export interface IWorkoutStats {
  totals?: IWorkoutTotals;
  muscleGroupPercentages?: IMuscleGroupPercentages;
  avWorkoutEffort?: IStat;
  avWorkoutCal?: IStat;
}

export enum WorkoutStat {
  Effort = 'avWorkoutEffort',
  Calories = 'Calories',
}

export enum ScanStat {
  Weight = 'weight',
  MuscleMassMeter = 'skeletalMuscleMass',
  PercentBodyFat = 'percentBodyFat',
}

export enum StatMonth {
  SelectedMonth = 'selectedMonth',
  PreviousMonth = 'previousMonth',
  MonthThree = 'monthThree',
  MonthFour = 'monthFour',
  MonthFive = 'monthFive',
  MonthSix = 'monthSix',
}

export enum RangeLevel {
  VeryLow,
  TooLow,
  Good,
  High,
  VeryHigh,
  Average,
  Bad,
}
